
export function arrayify(item) {
  if (!item) {
    return []
  }
  if (!Array.isArray(item)) {
    item = [item]
  }
  return item
}